module.exports = __webpack_public_path__ + "static/media/less-than.4a290e47.svg";